<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <form @submit.prevent="">
          <h1>Eviction Diversion Program Application</h1>
          <h2>Upload Required Documents</h2>
          <div>
            <div>For the Tenant: {{ TenantName }}</div>
            <div>At the address: {{ TenantAddress }}</div>
          </div>
          <callout type="info">
            <!--<div>
              Upload the following required Supporting Documents:
              <ul>
                <li>
                  Rent Ledger or detailed list of past due rent and fees.
                  <b>The document must include the property address, tenant name, and total amount past due.</b> A ledger is not required if you are not claiming past due rent/fees.
                  Acceptable ledger documents include:
                </li>
              </ul>
              <p class="faq-line-indent">
                o	A formal ledger from a property management system listing dates and amounts of all charges, payments, and amounts due for rent and fees since the date of move in or last zero balance.<br>
                o	A Word document, Excel spreadsheet, or handwritten document listing past due rent and fees with dates and amounts for each individual item. <a href="https://dpd-eviction-diversion-documents.s3.amazonaws.com/2022+Agreement+Template.docx">Click here for sample template</a>.<br>
                o	A Notice to Quit that lays out each month and fee being charged.<br>
              </p>
              <ul>
                <li>
                  Proof that <a href="https://dpd-eviction-diversion-documents.s3.amazonaws.com/NOTICE+OF+DIVERSION+RIGHTS+FINAL+3.10.2022.pdf">Notice of Diversion Rights</a> was delivered. Please visit the <a
                    href="https://eviction-diversion.phila.gov/#/FAQ"
                    target="_blank"
                  >FAQ</a> for acceptable forms of proof.
                </li>
              </ul>
            </div><br>-->

            <div>
              The file upload accepts images and PDFs, with a maximum file size of 4.5mb. <!--You must upload separate files for the Proof of
              Delivery document and the Rent Ledger via their individual select buttons. You may upload seperate files if you reach the file
              size limit on a single document. For the "additional files" selection,--> You may select multiple documents at a time.
            </div>
          </callout>
          <callout type="warning">
            <strong>Failure to upload the required supporting documents will result in your application being denied.</strong>
          </callout>
          <callout type="danger">
            <strong>IMPORTANT -- Please follow these steps to upload documents successfully:</strong>
            <ol>
              <li>Select the files you wish to upload using the blue button below.</li>
              <!--<li>The "Finish" button will appear in the bottom right corner of this page when documents have been selected for required fields.</li>-->
              <li>Once all files have been Selected, Click the Finish button to upload them.</li>
              <li>Do not hit the back button. Wait for the green message that all documents have uploaded before closing this page.</li>
            </ol>
          </callout>
          <div class="field-container file-uploads">
            <h3><b>File Uploads</b></h3>
          </div>
          <!--<h5>Proof of Delivery Document: <b style="color:red">(required)</b></h5>
          <ul id="upload-list-proof-of-delivery-documents">
            <li
              v-for="file in ProofOfDeliveryDocument"
              :key="file.id"
            >
              <span>{{ file.name }} - </span>
              <span
                v-if="file.error"
                class="is-love-park-red"
              >
                Something went wrong - {{ file.errorMessage }}
              </span>

              <span
                v-else-if="file.success"
                class="is-phanatic-green"
              >
                Upload Successful. Please select another document to upload if you have multiple documents.
              </span>
              <span
                v-else-if="file.uploading"
                class="is-flyers-orange"
              >
                Uploading Document...
              </span>
            </li>
          </ul>
          <file-upload
            ref="upload"
            v-model="ProofOfDeliveryDocument"
            :input-id="`file-upload-proof-of-delivery-files`"
            extensions="gif,jpg,jpeg,png,webp,pdf"
            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
            :size="1024 * 1024 * 4.5"
            @input-filter="inputFilter"
          >
            <button
              class="button is-primary"
              style="margin-bottom: 1%;"
            >
              <i class="fa fa-plus" />
              Select ONE File to Upload
            </button>
          </file-upload>
          <h5>Rent Ledger: <b style="color:red">(required)</b></h5>
          <ul id="upload-list-rent-ledger-documents">
            <li
              v-for="file in RentLedger"
              :key="file.id"
            >
              <span>{{ file.name }} - </span>
              <span
                v-if="file.error"
                class="is-love-park-red"
              >
                Something went wrong - {{ file.errorMessage }}
              </span>

              <span
                v-else-if="file.success"
                class="is-phanatic-green"
              >
                Upload Successful. Please select another document to upload if you have multiple documents.
              </span>
              <span
                v-else-if="file.uploading"
                class="is-flyers-orange"
              >
                Uploading Document...
              </span>
            </li>
          </ul>
          <file-upload
            ref="upload"
            v-model="RentLedger"
            :input-id="`file-upload-rent-ledger-files`"
            extensions="gif,jpg,jpeg,png,webp,pdf"
            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
            :size="1024 * 1024 * 4.5"
            @input-filter="inputFilter"
          >
            <button class="button is-primary">
              <i class="fa fa-plus" />
              Select ONE File to Upload
            </button>
          </file-upload><br><br>-->
          <h5>Additional Files:</h5>
          <ul id="upload-list-landlord-documents">
            <li
              v-for="file in LandlordFiles"
              :key="file.id"
            >
              <span>{{ file.name }} - </span>
              <span
                v-if="file.error"
                class="is-love-park-red"
              >
                Something went wrong - {{ file.errorMessage }}
              </span>

              <span
                v-else-if="file.success"
                class="is-phanatic-green"
              >
                Upload Successful. Please select another document to upload if you have multiple documents.
              </span>
              <span
                v-else-if="file.uploading"
                class="is-flyers-orange"
              >
                Uploading Document...
              </span>
            </li>
          </ul>
          <file-upload
            ref="upload"
            v-model="LandlordFiles"
            :input-id="`file-upload-landlord-files`"
            extensions="gif,jpg,jpeg,png,webp,pdf"
            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
            :multiple="true"
            :size="1024 * 1024 * 4.5"
            @input-filter="inputFilter"
          >
            <button
              class="button is-primary"
              style="margin-bottom: 1%;"
            >
              <i class="fa fa-plus" />
              Select Files to Upload
            </button>
          </file-upload>
          <p><b>Once all necessary files are selected, click FINISH to upload them.</b></p>
          <div class="actions columns">
            <!--Required criteria for above div: v-if="(ProofOfDeliveryDocument.length != 0 && RentLedger.length != 0)"-->
            <div
              class="column is-2 is-offset-20"
              style="margin-top:2%"
            >
              <button
                class="button is-primary"
                @click="submitFiles"
              >
                FINISH
              </button><br><br>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import FileUpload from "vue-upload-component";
import options from "@/utilities/options";

import buildLandlordFileDataObject from "@/utilities/data-objects/landlord-file-data-object-old-portal";
import buildLandlordDataFetchObject from "@/utilities/data-objects/landlord-data-fetch-object-old-portal";
import {
  dataObjectToXml,
  resizeImage,
  getBase64,
  getPropertyValueOrDefault,
} from "@/utilities/functions";

export default {
  name: "ApplicationFiles",
  components: { FileUpload },
  mixins: [options],
  props: {
    applicantId: { default: null, type: String },
  },
  data() {
    return {
      submitStatus: null,
      LandlordFiles: [],
      ProofOfDeliveryDocument: [],
      RentLedger: [],
      TenantName: null,
      TenantAddress: null,
    };
  },
  created() {
    var vData = this;
    const dataObject = buildLandlordDataFetchObject(vData.applicantId, "EDP_FILE_UPLOAD_DATA_REQUEST");
    const requestObj = {
      table: "bqseac2yd",
      data: dataObject,
    };
    axios
      .post(
        "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-Secure-Request-Proxy",
        requestObj,
      )
      .then((response) => {
        console.log("response for landlord file upload data request", response);
        const responseObject = getPropertyValueOrDefault(
          ["data", "record", "f"],
          response,
        );
        vData.TenantName = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "65"));
        vData.TenantAddress = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "23"));
      });
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    async handleFileUpload(uploadData) {
      if (uploadData.length) {
        let FileIdx = uploadData.length - 1;
        var vData = this;
        var fileObj = uploadData[FileIdx];
        fileObj.uploading = true;
        fileObj.error = false;
        fileObj.errorMessage = "";
        let file = fileObj.file;
        if (fileObj.type.match(/image.*/)) {
          file = await resizeImage({ file: file, maxSize: 1920 });
        }
        if (file.size >= 1024 * 1024 * 4.5) {
          fileObj.error = true;
          fileObj.errorMessage =
              "File is too large, please reduce your file's size and try again.";
        } else {
          const base64File = await getBase64(file);
          const dataObject = buildLandlordFileDataObject(
            vData.applicantId,
            fileObj.name,
            base64File,
          );
          const xmlDataObject = dataObjectToXml(dataObject);
          const requestObj = {
            table: "bqsu9cad4",
            action: "API_AddRecord",
            data: xmlDataObject,
          };
          axios
            .post(
              "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-QuickBase-Request-Proxy",
              requestObj,
            )
            .then(() => {
              fileObj.uploading = false;
              fileObj.success = true;
            })
            .catch(() => {
              fileObj.error = true;
              fileObj.errorMessage =
                  "File is too large, please reduce your file's size and try again.";
            });
        }
      }
    },
    finishApplication() {
      var vData = this;
      if (!vData.LandlordFiles.some(i => i.uploading)) {
        vData.$router.push({
          name: "Success",
        });
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async submitFiles() {
      var FileEntries = [];

      // get the keys to the files to know the number of files to be uploaded
      var numberOfFiles = Object.keys(this.LandlordFiles);

      // Remove all but the last file and place all other files in the FileEntries array
      for (var i = 0; i < numberOfFiles.length - 1; i++) {
        var currentFile = this.LandlordFiles.shift();
        FileEntries.push(currentFile);
      }

      // Upload the last file
      await this.handleFileUpload(this.LandlordFiles);

      // Replace the file in Landlord files with the other files that need to be uploaded and upload them
      for (var k = 0; k < FileEntries.length; k++) {
        this.LandlordFiles.splice(0, 1, FileEntries[k]);
        await this.handleFileUpload(this.LandlordFiles);
      }

      await this.handleFileUpload(this.RentLedger);
      await this.handleFileUpload(this.ProofOfDeliveryDocument);

      await this.sleep(3000);

      this.finishApplication();
    },
  },
};
</script>

<style scoped>
  .is-flyers-orange {
    color: hsl(35, 100%, 49%);
  }

  .is-phanatic-green {
    color: hsl(121.6, 38.6%, 37.1%);
  }

  .is-love-park-red {
    color: hsl(14.1, 100%, 40%);
  }
</style>
